export default __webpack_public_path__ + "static/media/Extreme.eff2de50.png";